import { faFacebook, faLinkedin, faWhatsapp, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames"

export const AppFooter = (props) => {

    const navigateTo = (url) => window.location.href = url;

    return (
        <footer>
            <div className="top-footer">
                <div className="quick-links">
                    <div className="link-caption">Quick Links</div>
                    <div className="link-section">
                        <a href="/infos" className="link-text">About us</a>
                        <a href="/banking" className="link-text">Accounts and banking</a>
                        <a href="/blog" className="link-text">Blog</a>
                        <a href="/loans" className="link-text">Loans</a>
                        <a href="/contactus" className="link-text">Contact us</a>
                    </div>
                </div>
                <div className="aicco-info">
                    <div className="info-box">
                        <div className="info-text">Affiliated to </div>
                        <div className="logo">
                            <a href="https://rainbowcam.org" > <img src="./images/pics/rainbowcam-logo-1.png" width="200" height="100" alt="" /></a>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                            <img src="./images/svgs/location.svg" width="80" height="80" alt="" />
                        </div>
                        <div className="info-caption">
                            <div className="title">Head office:</div>
                            <hr />
                            <div className="location">
                                North West Region, Santa, besides ENEO office, Santa Park.
                            </div>
                        </div>

                    </div>

                    <div className="info-box"></div>
                </div>
            </div>
            <div className="copy-bottom">
                <div className="soc-icons">
                    <FontAwesomeIcon 
                        icon={faFacebook} 
                        onClick={() => navigateTo("https://web.facebook.com/ayembeunion")}
                    />
                    <FontAwesomeIcon 
                        icon={faWhatsapp}
                        onClick={() => navigateTo("https://api.whatsapp.com/send?phone=%2B237691262498&context=Afd7bgLJh4_qRbYikTBvbyzDrlqZKQKvR3x6ncsWtVXtjL59FdeS3ZWS0WUBZwMEkBWuBJaDlxp8RDXAZn92MC8AGoVufx4TDGKXkkWyFMZNjLZpqanRZzvz1EDlKaU2yLnSjafGGhRmVGPfCJ01U6Wj1Q&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwY2xjawNRzDVleHRuA2FlbQIxMABicmlkETBGN2VSSkZiQ21pUXVWNHRIAR5QI-i7S2eXWNSWUgEmsYWJHZrgWdsvprrSE0AFXzzBHs3VJnEKg0Udia8bhw_aem_5rirjL23ZdK0_a0T8rZDnA")} 
                    />
                    <FontAwesomeIcon
                        icon={faLinkedin}
                        onClick={() => navigateTo("https://www.linkedin.com/company/ayembeunion")}
                    />
                </div>
                <span className={classNames("copy", "bottom-small")}>
                    Copyright &copy; AICCO <span className="year" id="this-year"></span>
                </span>
                <span className={classNames("privacy", "bottom-small")}>Privacy policy</span>
            </div>
        </footer>
    );
}